import React from 'react'
import { M_Table } from 'src/M_Components'

const Incoterms = ({ roles }) => {
  return (
    <M_Table entityName={'incoterms'} rolePermissions={roles} />
  )
}

export default Incoterms